import DocumentTitle from "react-document-title";
import UnderConstruction from "../Components/UnderConstruction";

export default function Faq() {
  return (
    <DocumentTitle title="FAQ">
      <UnderConstruction />
    </DocumentTitle>
  );
}
